<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingRacoes"
        @add="$router.push({ path: '/racao' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Identificador, Nome, Sigla, Código na empresa ou Status" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm11 xs11 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingRacoes"
                    :must-sort="true" :items="racoes" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'

export default {
    components: {
        AppMainSearchCard,
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idRacao', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Rações',
        registroSelected: '',
        headers: [            
            { text: 'Identificador', value: 'idRacao' },
            { text: 'Nome', value: 'nmRacao' },
            { text: 'Código na empresa', value: 'cdItem' },
            { text: 'Medicada', value: 'stMedicada' },
            { text: 'Status', value: 'dsStatus' },
        ],
        racoes: [],
        isLoadingRacoes: false,
        isErrorRacao: false,
        query: {},
        search: '',
    }),
    methods: {
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadFarmacos')
            this.query = Object.assign({}, route.query)
            this.searchItem()
        },
        editItem (value) {
            this.$router.push({ name: 'racao', params: { id : value.idRacao } })
        },
        searchItem() {
            var search = Object.assign({}, this.query)

            this.isLoadingRacoes = true

            this.$axios.get('racao/', { params: search })
            .then((response) => {
                if (response.data[0].data != null)
                {
                    var racoes = response.data[0].data.map(entry => {
                        let dsStatus = entry.flAtiva ? 'Ativa' : 'Inativa'
                        let stMedicada = entry.stMedicada != undefined ? entry.stMedicada == 'S' ? 'Sim' : 'Não' : 'Não'
                        return {...entry, dsStatus, stMedicada}
                    })

                    this.racoes = racoes
                }
            })
            .catch((error) => {
                this.isErrorRacao = true
                this.$store.commit("setSnack", { type: "error", msg: error })
            })
            .finally(() => {
                this.isLoadingRacoes = false
            })
        },
        routeUpdate() {
            this.$router.push({ path : 'racaoSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        options: {
            handler () {
                this.searchItem()
            },
            deep: true
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
